import { render, staticRenderFns } from "./acceptanceDetails.vue?vue&type=template&id=07b71375&scoped=true"
import script from "./acceptanceDetails.vue?vue&type=script&lang=js"
export * from "./acceptanceDetails.vue?vue&type=script&lang=js"
import style0 from "./acceptanceDetails.vue?vue&type=style&index=0&id=07b71375&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b71375",
  null
  
)

export default component.exports